<template>
  <div id="app">
    <!--缓存想要缓存的页面，实现后退不刷新-->
    <!--加上v-if的判断，可以自定义想要缓存的组件，自定义在router里面-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive && loadTip"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && loadTip"></router-view>

    <!--这里是其他的代码-->
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      loadTip: true
    };
  },
  methods: {
    reload() {
      this.loadTip = false;
      this.$nextTick(() => {
        this.loadTip = true;
      });
    }
  }
};
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/App.vue